var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        id: "app",
        width: "1000px",
        "close-on-click-modal": false,
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_SelectBill"),
        "append-to-body": "",
        "show-close": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.cancel
      }
    },
    [
      _c(
        "search-item",
        {
          ref: "searchItem",
          attrs: {
            "show-more-scheme": true,
            "show-simple": true,
            "expand-adv": true,
            "search-item-code": _vm.$t("Clearing.AddToBillQueryList"),
            "config-module": "5051",
            "auto-init": true,
            "append-to-body": "",
            "custom-search-items": _vm.customSearchItems,
            "col-settings": {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 12,
              xl: 12
            }
          },
          on: {
            advSearchItemCallBack: _vm.fetchData,
            "click-more": function(value) {
              return (_vm.isAdvancedQuery = value)
            }
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showAgentBilling,
                  expression: "showAgentBilling"
                }
              ],
              attrs: { slot: "operations" },
              slot: "operations"
            },
            [
              _c("span", { staticStyle: { "padding-left": "10px" } }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BillOfType")))
              ]),
              _c(
                "el-radio-group",
                {
                  staticStyle: { "padding-left": "10px" },
                  attrs: { disabled: true, no: "1" },
                  model: {
                    value: _vm.billingType,
                    callback: function($$v) {
                      _vm.billingType = $$v
                    },
                    expression: "billingType"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Domestic")))
                  ]),
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_International")))
                  ]),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _c(
                      "span",
                      {
                        staticStyle: { color: "#1f75d5", "font-size": "14px" }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AgentBilling")))]
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        { staticClass: "app-main-inner-row row-grid" },
        [
          _c("cargo-ag-grid", {
            style: { width: "100%", height: "300px" },
            attrs: {
              "config-module": "190906",
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "grid-params": _vm.gridParams,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-wrapper", attrs: { id: "footer-wrapper" } },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "flex-end",
                "flex-wrap": "wrap",
                "margin-top": "10px"
              }
            },
            [
              _vm.totalAmountToCurrency.selectedCount > 0
                ? _c("div", [
                    _c("span", [
                      _vm._v(
                        "选中 " +
                          _vm._s(_vm.totalAmountToCurrency.selectedCount) +
                          "："
                      )
                    ])
                  ])
                : _vm._e(),
              _vm.reCalc
                ? _c("charge-currency-total-group", {
                    attrs: {
                      "amount-to-currency": _vm.localCurrency,
                      "data-field": "amount",
                      "currency-field": "currency",
                      "ar-field": "ar",
                      type: "both",
                      "data-provider": _vm.totalAmountToCurrency.dataProvider
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c("cargo-pagination", {
            attrs: {
              "config-module": "190906",
              total: _vm.searchConditions.total,
              page: _vm.searchConditions.pageNum,
              limit: _vm.searchConditions.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.searchConditions, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.searchConditions, "pageSize", $event)
              },
              pagination: _vm.fetchDataByPage
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "2", size: "mini" },
              on: { click: _vm.confirmBillingGroup }
            },
            [_vm._v(_vm._s(_vm.$t("Invoice.invoice_confirm")))]
          ),
          _c(
            "el-button",
            { attrs: { size: "mini", no: "3" }, on: { click: _vm.cancel } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }